<template>
	<div class="content">
		<div class="contant">
			<div class="head">
				<img src="../assets/img/zx-banner.png">
			</div>
			<div class="vip">
				<div class="vip-title">
					VIP会员套餐
				</div>
				<!-- 会员盒子 -->
				<div class="bbox">
					<div class="vip-box">
						<div class="vip-boxtop">
							<img src="../assets/img/ryhy.png">
							<span class="vip-ry">荣誉会员</span>
						</div>
						<div class="vip-boxbot">
							<div class="vip-boxtext">
								<span class="num">699</span>元/年
							</div>
							<div class="vip-boxbottext">
								发布产品、赠送积分、</br>在线支付
							</div>
							<div class="vip-boxbut">
								<a href="#submit"><button type="button" @click="getApplay('荣誉会员')" >立即开通</button></a>
							</div>
						</div>
					</div>
					<!-- 第二个 -->
					<div class="vip-box">
						<div class="vip-boxtop">
							<img src="../assets/img/gjhy.png">
							<span class="vip-ry">高级会员</span>
						</div>
						<div class="vip-boxbot">
							<div class="vip-boxtext">
								<span class="num">1999</span>元/年
							</div>
							<div class="vip-boxbottext">
								发布产品、店铺定制、</br>
								在线支付、赠送积分</br>
								网站升级、免费推广</br>
							</div>
							<div class="vip-boxbut">
								<a href="#submit"><button type="button" @click="getApplay('高级会员')" >立即开通</button></a>
							</div>
						</div>
					</div>
					<!-- 第三个 -->
					<div class="vip-box">
						<div class="vip-boxtop">
							<img src="../assets/img/sxhy.png">
							<span class="vip-ry">首席会员</span>
						</div>
						<div class="vip-boxbot">
							<div class="vip-boxtext">
								<span class="num">6999</span>元/年
							</div>
							<div class="vip-boxbottext">
								发布产品、店铺定制、</br>
								在线支付、赠送积分</br>
								免费广告位、免费推广</br>
								网站升级、开通爱采购等</br>
							</div>
							<div class="vip-boxbut">
								<a href="#submit"><button type="button" @click="getApplay('首席会员')">立即开通</button></a>
							</div>
						</div>
					</div>
					<!-- 第四个 -->
					<div class="vip-box4">
						<!-- 背景图 -->
						<div class="box-img">
							<img src="../assets/img/ws.png">
						</div>
						<span class="zz"><b>至尊会员</b></span>
						<span class="qd">敬请期待····</span>
					</div>
				</div>
			</div>
			<div class="clear" style="clear: both;"></div>
			<div class="cont">
				<div class="contrast">
					<div class="con-title">
						会员权益及服务对比
					</div>
					<div class="con-table">
						<table border="0" cellspacing="0" cellpadding="0">
							<tr>
								<th rowspan='2' colspan="2">会员权益</th>
								<th>荣誉会员</th>
								<th>高级会员</th>
								<th>首席会员</th>
								<th>旗舰店</th>
								<th>品融店(行业)</th>
								<th>平台中平台(产业)</th>
							</tr>
							<!-- 第一行 -->
							<tr>
								<td class="one">
									<span class="num">699元</span>
									<a href="#submit"><button type="button"  @click="getApplay('荣誉会员')">立即开通</button></a>
								</td>
								<td class="one">
									<span class="num">1999元</span>
									<a href="#submit"><button type="button"   @click="getApplay('高级会员')">立即开通</button></a>
								</td>
								<td class="one">
									<span class="num">6999元</span>
									<a href="#submit"><button type="button"   @click="getApplay('首席会员')">立即开通</button></a>
								</td>
								<td class="one">
									<span class="num">19999元</span>
									<a href="#submit"><button type="button"   @click="getApplay('旗舰店')">立即开通</button></a>
								</td>
								<td class="one">
									<span class="num">29999元</span>
									<a href="#submit"><button type="button"  @click="getApplay('品融店(行业)')">立即开通</button></a>
								</td>
								<td class="one">
									<span class="num">49999元</span>
									<a href="#submit"><button type="button"  @click="getApplay('平台中平台(产业)')">立即开通</button></a>
								</td>
							</tr>
							<!-- 第二行 -->
								<tr class="two">
									<td rowspan="13">店 </br>铺</td>
									<td>开通店铺</td>
									<td>1</td>
									<td>1</td>
									<td>1</td>
									<td>1</td>
									<td>1</td>
									<td>1</td>
								</tr>
								<tr class="noT">
									<td>发布产品</td>
									<td>200</td>
									<td>500</td>
									<td>2000</td>
									<td>4000</td>
									<td>8000</td>
									<td>无限</td>
								</tr>
								<tr class="noT">
									<td>上传视频</td>
									<td> 2 </td>
									<td> 10 </td>
									<td> 20 </td>
									<td> 200</td>
									<td> 400</td>
									<td> 无限</td>
								</tr>
								<tr class="noT">
									<td>一键搬家</td>
									<td> 2 </td>
									<td> 20 </td>
									<td> 50 </td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<!-- 第4个 -->
								<tr class="noT">
									<td>发布资讯</td>
									<td> 100 </td>
									<td> 200 </td>
									<td> 300 </td>
									<td> 1000 </td>
									<td> 2000 </td>
									<td> 无限 </td>
								</tr>
								<!-- 第5个 -->
								<tr class="noT">
									<td>发布技术文章</td>
									<td> 100 </td>
									<td> 200 </td>
									<td> 300 </td>
									<td> 1000 </td>
									<td> 2000 </td>
									<td> 无限 </td>
								</tr>
								<!-- 第6行 -->
								<tr class="noT">
									<td>店铺模板(pc+移动)</td>
									<td> 原价 </td>
									<td> 赠1模板 </td>
									<td> 赠1模板 </td>
									<td> 赠2模板 </td>
									<td> 赠4模板 </td>
									<td> 所有模板 </td>
								</tr>
								<!-- 7 -->
								<tr class="noT">
									<td>升级网站(绑定公司名称)</td>
									<td> 原价 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
								</tr>
								<!--  8-->
								<tr class="noT">
									<td>店铺定制（pc+移动）</td>
									<td> 原价 </td>
									<td> 原价 </td>
									<td> 赠送一次 </td>
									<td> 赠送二次 </td>
									<td> 赠送三次 </td>
									<td> 赠送四次 </td>
								</tr>
								<!-- 9 -->
								<tr class="noT">
									<td>百度小程序</td>
									<td> 原价 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
								</tr>
								<tr class="noT">
									<td>微信小程序</td>
									<td> 原价 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
									<td> 免费 </td>
								</tr>
								<!-- 10 -->
								<tr class="noT">
									<td>产品刷新</td>
									<td> 10积分/次 </td>
									<td> 10积分/次  </td>
									<td> 体验20次 </td>
									<td> 赠送100次</td>
									<td> 赠送200次</td>
									<td> 免费</td>
								</tr>
								<!-- 11 -->
								<tr class="noT">
									<td>相册管理</td>
									<td> 150张 </td>
									<td> 300张  </td>
									<td> 500张 </td>
									<td> 2000张 </td>
									<td> 4000张 </td>
									<td> 无限 </td>
								</tr>
								<!-- 12 -->
								<tr class="two">
									<td rowspan="4">积</br> 分</br> 系</br> 统</td>
									<td>积分交易</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>积分兑换</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>积分商城</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>会员升级</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="two">
									<td rowspan="5">广</br> 告</br> 系</br> 统</td>
									<td>平台首页广告位（含手机端首页）</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1张/15天</td>
									<td>2张/30天</td>
									<td>3张/30天</td>
									<td>6张/30天</td>
								</tr>
								<tr class="noT">
									<td>供应频道首屏广告</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1张/15天</td>
									<td>2张/30天</td>
									<td>3张/30天</td>
									<td>6张/30天</td>
								</tr>
								<tr class="noT">
									<td>供应频道楼层广告</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1张/15天</td>
									<td>2张/30天</td>
									<td>3张/30天</td>
									<td>6张/30天</td>
								</tr>
								<tr class="noT">
									<td>店铺装修首页整页</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1次</td>
									<td>2次</td>
									<td>3次</td>
									<td>6次</td>
								</tr>
								<tr class="noT">
									<td>供应搜索结构关键词固定排名</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1</td>
									<td>2</td>
									<td>2</td>
									<td>3</td>
									<td>6</td>
								</tr>
	
								<tr class="two">
									<td rowspan="5">美</br>工</br>UL设计</td>
									<td>产品主图设计</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1张 </td>
									<td>4张</td>
									<td>8张</td>
									<td>12张</td>
								</tr>
								<tr class="noT">
									<td>轮播大图一张</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1次 </td>
									<td>2次</td>
									<td>4次</td>
									<td>8次</td>
								</tr>
								<tr class="noT">
									<td>店铺店招设计</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1张 </td>
									<td>2张</td>
									<td>4张</td>
									<td>8张</td>
								</tr>
								<tr class="noT">
									<td>白底主图</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1张 </td>
									<td>2张</td>
									<td>4张</td>
									<td>8张</td>
								</tr>
								<tr class="noT">
									<td>详情页设计</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td>1次 </td>
									<td>2次</td>
									<td>4次</td>
								</tr>
								<!-- 16 -->
								<tr class="two">
									<td rowspan="16">推</br>广</td>
									<td>平台推广</td>
									<td> 原价 </td>
									<td> 原价 </td>
									<td>优惠 </td>
									<td>优惠 </td>
									<td>优惠 </td>
									<td>优惠 </td>
								</tr>
								
								<tr class="noT">
									<td>公众号推广</td>
									<td>原价</td>
									<td> 1次</td>
									<td> 2次</td>
									<td> 6次</td>
									<td> 12次</td>
									<td> 24次</td>
								</tr>
								<tr class="noT">
									<td>爱采购推广</td>
									<td> 原价 </td>
									<td> 原价 </td>
									<td>原价 </td>
									<td>优惠 </td>
									<td>优惠 </td>
									<td>优惠 </td>
								</tr>
								<tr class="noT">
									<td>搜索引擎优化推广</td>
									<td> 原价 </td>
									<td> 原价 </td>
									<td>原价 </td>
									<td>优惠 </td>
									<td>优惠 </td>
									<td>优惠 </td>
								</tr>
								<tr class="noT">
									<td>店铺托管</td>
									<td> 原价 </td>
									<td> 原价 </td>
									<td>原价 </td>
									<td>免费 </td>
									<td>免费 </td>
									<td>免费 </td>
								</tr>
								<tr class="noT">
									<td>平台代理产品</td>
									<td> 原价 </td>
									<td> 原价 </td>
									<td>原价 </td>
									<td>优惠 </td>
									<td>优惠 </td>
									<td>优惠 </td>
								</tr>
								<tr class="noT">
									<td>商机订阅</td>
									<td> 20积分/次 </td>
									<td> 20积分/次 </td>
									<td> 20积分/次</td>
									<td> 20积分/次 </td>
									<td> 20积分/次 </td>
									<td> 20积分/次</td>
								</tr>
								<tr class="noT">
									<td>在线交易</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>平台采购</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>产品代理价</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>关键词置顶</td>
									<td> 原价 </td>
									<td> 8折 </td>
									<td> 5折 </td>
									<td> 2个免费关键词(5折) </td>
									<td> 4个免费关键词(5折) </td>
									<td> 10个免费关键词(5折) </td>
								</tr>
								<tr class="noT">
									<td>供应搜索结果关键词固定排名</td>
									<td> 1次</td>
									<td> 1次</td>
									<td> 2次</td>
									<td> 6次</td>
									<td> 12次</td>
									<td> 24次</td>
								</tr>
								<tr class="noT">
									<td>一站式服务推荐</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>独立后台系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>SEO自主设置系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>平台分佣系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
	
								<tr class="two">
									<td rowspan="12">旗</br>舰</br>店</br>后</br>台</br>管</br>理</br></td>
									<td>入驻商管理系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>会员管理系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>消息模板系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>商机管理系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>交易管理系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>用户管理系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>营销板块系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>广告管理系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>数据分析系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>金融服务系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>支付保障系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>一键搬家系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="two">
									<td rowspan="2">订</br>单</br>系</br>统</td>
									<td>自有订单管理</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>会员订单管理</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="two">
									<td rowspan="2">辅</br>助</br>功</br>能</td>
									<td>专属客服系统</td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td><i class="iconfont icon-cuo"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
								<tr class="noT">
									<td>24小时电话客服</td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
									<td> <i class="iconfont icon-zhengque-correct"></i></td>
								</tr>
	
						</table>
					</div>
				</div>
		
				<!-- 入住
				<!-- <div id="submit" class="req">
					<div class="req-text">
						立即开通
					</div>
					<form  onsubmit="return false;">
						<table border="0" cellspacing="0" cellpadding="0">
							<input type="hidden" name="user_id" value="{$Think.session.user_info.id}"/>
							<input type="hidden" name="content" value="VIP专享权益"/>
							<tr>
								<td class="tname">公司名称 &nbsp;</td>
								<td> <input type="text" name="seller_name"  placeholder="请输入公司名称" /> </td>
							</tr>
							<tr>
								<td class="tname">联系人&nbsp;</td>
								<td> <input type="text" name="username"  placeholder="请输入联系人" /> </td>
							</tr>
							<tr>
								<td class="tname"><span class="iphone">*</span>手机号&nbsp;</td>
								<td onsubmit="checkPhone()">
									<input  type="text" name="phone" id="iphone" required placeholder="请输入手机号" />
								</td>
							</tr>
							<tr class="tx">
								<td class="tname"> <span class="txyz">*</span>图形验证码&nbsp;</td>
								<td align="left">
									<input type="text" name="yzmcode" required placeholder="请输入图形验证码" />
									<div class="tx-img"><img src="{:captcha_src()}" onclick="this.src='{:captcha_src()}?'+Math.random();" /> </div>
								</td>
							</tr>
							<tr class="yz">
								<td class="tname"><span class="yzm">*</span>短信验证码 &nbsp;</td>
								<td align="left">
									<input type="text" name="phonecode" required placeholder="请输入短信验证码" />
									<button class="tx-btn">获取验证码</button>
								</td>
							</tr>
						</table>
						<input class="submit" type="button" name="submit" value="提交申请" />
					</form>
				</div> -->
		
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		},
		methods:{
			getApplay(project) {
				let params={
					project
				}
				this.$axios.post('Myseller-setting-applyService',params).then(data => {
					if (data.code == 41004) {
						this.$message.error(data.msg)
						return
					}else{
						this.$alert('申请成功，我们的客户经理将于1个工作日内与您联系！', project, {
							type: 'success'
						})
					}
				})
			},
		}
	}
</script>
<style scoped="scoped">
	.head{
		width: 100%;
	}
	.head img{
		width: 100%;
	}
	.vip{
		width: 1200px;
		margin: 0 auto;
		/* overflow: hidden; */
		padding-bottom: 80px;
		
	}
	.vip .vip-title{
		font-size: 28px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}
	/* 中间盒子 */
	
	.vip .bbox{
		width: 1200px;
		float: left;
		padding-bottom: 60px;
		/* border: 1px solid forestgreen; */
	}
	.vip .bbox .vip-box{
		float: left;
	}
	.vip .bbox .vip-box{
		margin-right: 29px;
	}
	.vip .bbox .vip-box:nth-last-child{
		margin-right: none;
	}
	/*  */
	.vip .bbox .vip-box,.vip .bbox .vip-box4{
		width: 276px;
		height: 394px;
		border: 1px solid #ccc;
		overflow: hidden;
		text-align: center;
		border-radius: 5px;
	}
	/*盒子间距 */
	.vip .box:first-child{
		margin-left: none;
	}
	
	
	
	.vip .bbox .vip-box .vip-boxtop{
		/* width: 276px; */
		/*width: 114px;*/
		/*line-height: 60px;*/
		color: #999;
		font-size: 20px;
		text-align: center;
		position: relative;
	}
	.vip .bbox .vip-box .vip-boxtop img{
		width: 295px;
	}
	.vip .bbox .vip-box .vip-boxtop .vip-ry{
		/*width: 276px;*/
		/*padding: 15px 0;*/
		display: block;
		color: #fff;
		font-size: 26px;
		z-index: 10;
		position: absolute;
		top: 30px;left: 0;
		bottom: 0;right: 0;
	}
	/* 中间 */
	.vip .bbox .vip-box  .vip-boxbot{
		color: #999;
		font-size: 20px;
	}
	.vip .bbox .vip-box  .vip-boxbot .vip-boxtext{
		font-size: 20px;
		height: 50px;
		line-height: 50px;
	}
	.vip .bbox .vip-box  .vip-boxbot .vip-boxtext .num{
		color: #000;
		font-size: 46px;
	}
	.vip .bbox .vip-box  .vip-boxbot .vip-boxbottext{
		font-size: 15px;
	    height: 100px;
	    line-height: 24px;
	    padding: 20px 0;
	}
	.vip .bbox .vip-box  .vip-boxbot .vip-boxbut{
		margin: 0 auto;
	}
	
	.vip .bbox .vip-box  .vip-boxbot .vip-boxbut button{
		width: 216px;
		height: 46px;
		line-height: 46px;
		color: #fff;
		border-radius: 10px;
		border: 1px solid transparent;
		background-color:#1c4fe3;
	}
	.vip .bbox .vip-box4{
		background: url('../assets/img/bj.png') no-repeat;
		overflow: hidden;
		position: relative;
	}
	.vip .bbox .vip-box4 .box-img{
		width:287px;
		height: 200px;
		display: table-cell;
		vertical-align: middle;
	}
	.vip .bbox .vip-box4 .box-img img{
		width: 94px;
	}
	.vip .bbox .vip-box4 .zz{
		font-size:26px;
	}
	.vip .bbox .vip-box4 .qd{
		font-size: 24px;
	}
	.vip .bbox .vip-box4 .zz,.vip .vip-box4 .qd{
		color: #fff;
		display: block;
		height: 50px;
		line-height: 50px;
	}
	.cont{
		width: 100%;
		background-color: #f3f4f7;
	}
	.contrast{
		width: 1200px;
		margin: 0 auto;padding-bottom: 20px;
		
	}
	.contrast .con-title{
		text-align: center;
		font-size: 28px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}
	.contrast .con-table{
		width: 1200px;
		margin: 0 auto;
		font-size: 16px;
		color: #666;
		
	}
	.contrast .con-table table{
		
	}
	.contrast .con-table table tr th{
		width: 160px;
		height: 78px;
		color: #fff;
		font-size: 20px;
	}
	.contrast .con-table table tr th:nth-child(1){
		color: #666;
		font-size: 26px;
		background-color: #fff;
		
	}
	.contrast .con-table table tr th:nth-child(2){
		background-color: #b5bdff;
		
	}
	.contrast .con-table table tr th:nth-child(3){
		background-color: #6ac7fc;
		
	}
	.contrast .con-table table tr th:nth-child(4){
		background-color: #318cf7;
		
	}
	.contrast .con-table table tr th:nth-child(5){
		background-color: #2f63df;
	}
	.contrast .con-table table tr th:nth-child(6){
		background-color: #0f46cb;
	}
	.contrast .con-table table tr th:nth-child(7){
		background-color: #002c94;
	}
	.contrast .con-table table tr td{
		height: 100px;
		text-align: center;
		margin: 0 auto;
		
	}
	/* diyihang  */
	.contrast .con-table table tr .one:nth-child(1){
		background-color: #f8f9fe;
	}
	.contrast .con-table table tr .one:nth-child(2){
		background-color: #f1f8fc;
	}
	.contrast .con-table table tr .one:nth-child(3){
		background-color: #ecf5fd;
	}
	.contrast .con-table table tr .one:nth-child(4){
		background-color: #dbebf9;
	}
	.contrast .con-table table tr .one:nth-child(5){
		background-color: #cde5f9;
	}
	.contrast .con-table table tr .one:nth-child(6){
		background-color: #c3e2fc;
	}
	/* 第3列 */
	table tr.two td:nth-child(3) {
	background-color: #f8f9fe;
	}
	table tr.noT td:nth-child(2){
		background-color: #f8f9fe;
	}
	table tr.two td:nth-child(4) {
	background-color: #f1f8fc;
	}
	table tr.noT td:nth-child(3){
		background-color: #f1f8fc;
	}
	table tr.two td:nth-child(5) {
	background-color: #ecf5fd;
	}
	table tr.noT td:nth-child(4){
		background-color: #ecf5fd;
	}
	
	table tr.two td:nth-child(6) {
	background-color: #dbebf9;
	}
	table tr.noT td:nth-child(5){
		background-color: #dbebf9;
	}
	
	table tr.two td:nth-child(7) {
	background-color: #cde5f9;
	}
	table tr.noT td:nth-child(6){
		background-color: #cde5f9;
	}
	table tr.two td:nth-child(8) {
	background-color: #c3e2fc;
	}
	table tr.noT td:nth-child(7){
		background-color: #c3e2fc;
	}
	table tr td[content="√"]{
		color: #3cf55a;
	}
	/* 店铺背景 */
	.contrast .con-table table .two td:nth-child(1),.contrast .con-table table .two td:nth-child(2),.contrast .con-table table tr td:nth-child(1){
		background-color: #fff;
		border: 1px solid #f2f7fc;
	}
	/* 店铺的宽 */
	.contrast .con-table table .two td:nth-child(1){
		width: 59px;
	}
	/* 第一行整个的表格 */
	.contrast .con-table table tr .one{
		border: none;
	}
	.contrast .con-table table tr td{
		border: 1px solid #fff;
		height: 56px;
	}
	
	.contrast .con-table table tr td .num{
		display: block;
		height: 50px;
		line-height: 50px;
		text-align: center;
		font-size: 24px;
		color: #000;
	}
	.contrast .con-table table tr td button{
		width: 122px;
		height: 37px;
		background-color: #002FA6;
		border-radius: 6px;
		color: #fff;
		border: 1px solid transparent;margin-bottom: 15px;
	}
	/* 最下边的图片 */
	.contrast .con-table table tr .img{
		
	}
	
</style>
